var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserBlacklist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0452 9.95429C16.3533 9.65999 16.8416 9.67114 17.1359 9.9792L18.0241 10.9089L18.9537 10.0207C19.2618 9.72641 19.7501 9.73757 20.0444 10.0456C20.3387 10.3537 20.3276 10.842 20.0195 11.1363L19.0898 12.0245L19.978 12.9541C20.2723 13.2622 20.2611 13.7505 19.9531 14.0448C19.645 14.3391 19.1567 14.3279 18.8624 14.0199L17.9743 13.0902L17.0446 13.9784C16.7365 14.2727 16.2482 14.2615 15.9539 13.9535C15.6596 13.6454 15.6708 13.1571 15.9788 12.8628L16.9085 11.9746L16.0203 11.045C15.726 10.7369 15.7372 10.2486 16.0452 9.95429Z",
    fill: "#911A1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94288 3C7.52861 3 5.57146 4.95715 5.57146 7.37143C5.57146 9.7857 7.52861 11.7429 9.94288 11.7429C12.3572 11.7429 14.3143 9.7857 14.3143 7.37143C14.3143 4.95715 12.3572 3 9.94288 3Z",
    fill: "#911A1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5226 13.6877C10.8136 13.4149 9.07216 13.4149 7.36316 13.6877L7.17997 13.7169C4.77192 14.1012 3.00003 16.1783 3.00003 18.6168C3.00003 19.933 4.06701 21 5.38319 21H14.5026C15.8188 21 16.8857 19.933 16.8857 18.6168C16.8857 16.1783 15.1138 14.1012 12.7058 13.7169L12.5226 13.6877Z",
    fill: "#911A1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserBlacklist);
export default __webpack_public_path__ + "static/media/icon-user-blacklist.f5199e61c49ce09589d4e5203ae8b79d.svg";
export { ForwardRef as ReactComponent };